import { Decimal } from 'decimal.js';
import { User } from './user.model';

// --- ENUMOK (A séma szerinti pontos értékekkel) ---
export enum ContactPersonType {
  HDC = 'HDC',
  COMMON = 'COMMON',
  CSABA = 'CSABA',
  DAVID = 'DAVID'
}

export enum WalletTransactionType {
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
  TRANSFER = 'TRANSFER',
  TRADE = 'TRADE',
  ROBOT = 'ROBOT'
}

export enum WalletType {
  FIX = 'FIX',
  ROBOT = 'ROBOT',
  TRADE = 'TRADE'
}

// --- ADATBÁZIS MODELLEK ---

export interface Assets {
  id: number;
  name: string;
  symbol: string;
  BMP_CryptoTrades?: BMP_CryptoTrades[];
}

export interface BMP_Investment {
  id: number;
  user_id: number;
  // user?: User; // Feltételezve, hogy van User interfészed
  date: Date;
  investedEur: Decimal | null;
  investedUsd: Decimal | null;
  zeroPointThreeBankFee: Decimal | null; // Sémában így szerepel
  fixTenEuroBankFee: Decimal | null;     // Sémában így szerepel
  usdChangeBankFee: Decimal | null;      // Sémában így szerepel
  costDeduction: Decimal | null;
  netInvestedUsd: Decimal | null;
  contactPerson: ContactPersonType;
  monthlyInvestments?: BMP_MonthlyInvestment[];

  user?: User;
}

export interface BMP_Buffer {
  id: number;
  user_id: number;
  pufferedUsd: Decimal | null;

  user?: User;
}

export interface BMP_MonthlyInvestment {
  id: number;
  monthCounter: number;
  user_id: number;
  date: Date;
  investedUsd: Decimal | null;
  bmp_investment_id: number;
  bmp_investment?: BMP_Investment;
  investedFlag: boolean;
  deposit_participant_id: number | null; // Sémában snake_case
  depositParticipant?: BMP_DepositParticipant | null;

  user?: User;
}

export interface BMP_DepositGroup {
  id: number;
  date: Date;
  groupDepositUsd: Decimal | null;
  unitRate: Decimal | null; // TypeScript-ben totalUnitRate volt, de sémában unitRate
  bitcoinExchangeRate: Decimal | null;
  ethereumExchangeRate: Decimal | null;
  liquidityShare: Decimal | null;
  participants?: BMP_DepositParticipant[];
  BMP_WalletAuditTrail?: BMP_WalletAuditTrail[];
  BMP_CryptoTrades?: BMP_CryptoTrades[];

  fixBtcRatio: Decimal | string;
  fixEthRatio: Decimal | string;
  robotBtcRatio: Decimal | string;
  robotLiquidityRatio: Decimal | string;
  tradingBtcRatio: Decimal | string;
  tradingEthRatio: Decimal | string;
  tradingLiquidityRatio: Decimal | string;

  BMP_GroupWallet?: BMP_GroupWallet;

  note?: string;
}

export interface BMP_GroupWallet {
  id: number;
  depositGroup_id: number; // Sémában snake_case
  depositGroup?: BMP_DepositGroup;
  
  fixBtc: Decimal | null;
  fixEth: Decimal | null;
  robotLiquidity: Decimal | null;
  robotBtc: Decimal | null;
  tradingBtc: Decimal | null;
  tradingEth: Decimal | null;
  tradingLiquidity: Decimal | null;

  createdAt: Date;
  updatedAt: Date;
}

export interface BMP_DepositParticipant {
  id: number;
  user_id: number;
  depositGroup_id: number; // Sémában snake_case
  depositGroup?: BMP_DepositGroup;
  depositUsd: Decimal | null;
  units: Decimal | null;

  monthlyInvestment?: BMP_MonthlyInvestment | null;
  user?: User;
}

export interface BMP_SystemWallets {
  id: number;
  fixBtc: Decimal | null;
  fixEth: Decimal | null;
  robotBtc: Decimal | null;
  robotLiquidity: Decimal | null;
  tradingBtc: Decimal | null;
  tradingEth: Decimal | null;
  tradingLiquidity: Decimal | null;
}

export interface BMP_WalletAuditTrail {
  id: number;
  date: Date;
  walletTransactionType: WalletTransactionType;
  fixBtc: Decimal | null;
  fixEth: Decimal | null;
  robotBtc: Decimal | null;
  robotLiquidity: Decimal | null;
  tradingBtc: Decimal | null;
  tradingEth: Decimal | null;
  tradingLiquidity: Decimal | null;
  depositGroupId: number | null; // Sémában camelCase
  depositGroup?: BMP_DepositGroup | null;
  cryptoTradeId: string | null;
  cryptoTrade?: BMP_CryptoTrades | null;
  walletTransferId: string | null;
  walletTransfer?: BMP_WalletTransfer | null;
  userId: number; // Sémában userId, nem user_id
  createdBy?: User; // User típus
  note: string;
}

export interface BMP_WalletTransfer {
  id: string;
  date: Date;
  source: WalletType;
  destination: WalletType;
  btcQuantity: Decimal | null;
  ethQuantity: Decimal | null;
  liquidityAmount: Decimal | null;
  userId: number;

  depositGroupId: number;
  depositGroup?: BMP_DepositGroup;

  // createdBy?: User;
  BMP_WalletAuditTrail?: BMP_WalletAuditTrail[];
}

export interface BMP_CryptoTrades {
  id: string;
  date: Date;
  operation: boolean;
  assetType: number;
  asset?: Assets; 
  quantity: Decimal | null;
  exchange_rate: Decimal | null;
  amount: Decimal | null;
  note: string;
  userId: number;
  // createdBy?: User;
  depositGroupId: number;
  depositGroup?: BMP_DepositGroup;
  BMP_WalletAuditTrail?: BMP_WalletAuditTrail[];
}

export interface BMP_RobotProduction {
  id: string;
  date: Date;
  assetType: number;
  asset?: Assets; 
  producedQuantity: Decimal | null;
  note: string;
  userId: number;
  createdBy?: User;

  depositGroupId: number;
  depositGroup?: BMP_DepositGroup;
}

// Automatic Alerts

export enum AutomaticAlertStatus {
  SENT = 'SENT',
  COMPLETED = 'COMPLETED',
}

export enum RealizationStrategy {
  LEVEL_1 = 'LEVEL_1',
  LEVEL_2 = 'LEVEL_2',
  LEVEL_3 = 'LEVEL_3',
  LEVEL_4 = 'LEVEL_4',
  LEVEL_5 = 'LEVEL_5',
}

export enum BuyingStrategy {
  LEVEL_1 = 'LEVEL_1',
  LEVEL_2 = 'LEVEL_2',
  LEVEL_3 = 'LEVEL_3',
}

export interface BMP_AutomaticAlert {
  id: string;
  date: Date;

  depositGroup_id: number;
  depositGroup?: BMP_DepositGroup;

  assetType: number;
  asset?: Assets;

  exchangeRate: Decimal | null;
  quantity: Decimal | null;
  amount: Decimal | null;

  alertRealizationLevel: RealizationStrategy;
  alertBuyingLevel: BuyingStrategy;

  automaticAlertStatus: AutomaticAlertStatus;

  operatorUserId: number | null;
  operatedBy?: User | null;

  operation: boolean;
}

// --- API / SZÁMÍTOTT TÍPUSOK (Változatlanul) ---

export interface WalletHoldingsUsd {
  fixBtc: Decimal | null;
  fixEth: Decimal | null;
  robotBtc: Decimal | null;
  tradingBtc: Decimal | null;
  tradingEth: Decimal | null;
}

export interface MarketPrices { btc: number; eth: number; }

export interface GetWalletResponse {
  wallet: BMP_SystemWallets;
  holdingsUsd: WalletHoldingsUsd | null;
  totalValueUsd: Decimal | null;
  totalUnits: Decimal | null;
  marketPrices: MarketPrices | null;
  timestamp: number;
  error?: string;
}

///

export interface MonthlyCostDeduction {
  label: string;       // Pl: "2023 - 10"
  humanDC: number;
  csaba: number;
  david: number;
  total: number;
}

export interface CostDeductionResponse {
  summary: {
    humanDC: number;
    csaba: number;
    david: number;
    grandTotal: number;
  };
  months: MonthlyCostDeduction[];
}

export interface MonthlyWalletIncrement {
  label: string;
  fixBtc: number;
  fixEth: number;
  robotBtc: number;
  robotLiquidity: number;
  tradingBtc: number;
  tradingEth: number;
  tradingLiquidity: number;
}

export interface WalletIncrementsResponse {
  summary: {
    fixBtc: number;
    fixEth: number;
    robotBtc: number;
    robotLiquidity: number;
    tradingBtc: number;
    tradingEth: number;
    tradingLiquidity: number;
  };
  months: MonthlyWalletIncrement[];
}

///

///

export interface BMP_CostDeduction {
  id: string;
  date: Date;
  contactType: ContactPersonType;
  amount: Decimal | null;
  payoutDate?: Date;
  isPaid: boolean;

  investmentId: number;
  investment: BMP_Investment;
}

// --- ÚJ TÍPUSOK A makeDepositService VISSZATÉRÉSÉHEZ ---

export interface WalletAssetBreakdown {
  btcUsd: Decimal;
  btcAmt: Decimal;
  ethUsd: Decimal;
  ethAmt: Decimal;
}

export interface RobotBreakdown {
  liquidityUsd: Decimal;
  btcUsd: Decimal;
  btcAmt: Decimal;
}

export interface TradingBreakdown extends WalletAssetBreakdown {
  liquidityUsd: Decimal;
}

export interface DepositBreakdown {
  fix: WalletAssetBreakdown;
  robot: RobotBreakdown;
  trading: TradingBreakdown;
}

export interface MakeDepositResponse {
  depositGroupId: number;
  participantsCount: number;
  appliedRate: string; // A .toString() miatt string
  status: 'SUCCESS' | 'ERROR';
  breakdown: DepositBreakdown;
}
